<template>
  <div class="home-container">
    <div class="header-bg">
      <div class="header-content">
        <div class="logo-section">
          <img
            src="../assets/images/homeLogo.png"
            alt="logo"
            class="logo-image"
          />
        </div>
      </div>
    </div>
    <div class="bottom-bg">
      <div class="enter-section">
        <div class="enter-btn" @click="goToMain">
          <div class="enter-text">点击进入</div>
        </div>
      </div>
      <div class="right"></div>
      <div class="finger"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import actionEvent from "@/utils/actionEvent.js";
import { debugApi } from "@/api/index";
// 导入微信 JS-SDK（当前文件保留能力，默认未启用分享初始化）
import wx from "weixin-js-sdk";

const router = useRouter();

const goToMain = () => {
  router.replace("/main");
};

/**
 * 初始化微信分享
 */
async function initWechatShare() {
  try {
    const url = window.location.href;
    const res = await debugApi.getWechatSignature({ url: url });
    const { appId, timestamp, nonceStr, signature } = res.data;

    // 配置微信JSSDK
    wx.config({
      debug: false, // 生产环境建议关闭debug
      appId: appId,
      timestamp: timestamp,
      nonceStr: nonceStr,
      signature: signature,
      jsApiList: [
        "updateAppMessageShareData",
        "updateTimelineShareData",
        "openLocation",
        "onMenuShareTimeline", // 朋友圈分享（兼容老版本）
        "onMenuShareAppMessage", // 朋友分享（兼容老版本）
      ],
    });

    wx.ready(() => {
      // 当前页面的动态内容（建议从页面获取实际内容）
      const shareData = {
        title: document.title || "我来上粤超！一键生成你的城市卡通海报",
        desc:
          document.querySelector('meta[name="description"]')?.content ||
          "为城市打Call，玩起来！",
        link: 'https://static.ycwb.com/ycpai/superLeague/#/',
        imgUrl:
          document.querySelector('meta[property="og:image"]')?.content ||
          "https://static.ycwb.com/ycp/img/shareLogoYC.png",
      };

      // 分享给朋友 - 新API
      wx.updateAppMessageShareData({
        title: shareData.title,
        desc: shareData.desc,
        link: shareData.link,
        imgUrl: shareData.imgUrl,
        success: () => {
          console.log("分享给朋友配置成功");
        },
        fail: (error) => {
          console.error("分享给朋友配置失败:", error);
        },
      });

      // 分享到朋友圈 - 新API
      wx.updateTimelineShareData({
        title: shareData.title,
        link: shareData.link,
        imgUrl: shareData.imgUrl,
        success: () => {
          console.log("分享到朋友圈配置成功");
        },
        fail: (error) => {
          console.error("分享到朋友圈配置失败:", error);
        },
      });
    });
  } catch (error) {
    console.log(error);
  }
}

onMounted(() => {
  actionEvent('view');
  initWechatShare();
  // 显示屏幕分辨率信息
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const innerWidth = window.innerWidth;
  const innerHeight = window.innerHeight;
  const devicePixelRatio = window.devicePixelRatio;
  const screenRatio = (screenHeight / screenWidth).toFixed(2);
  
  const screenInfo = `屏幕分辨率信息：
屏幕宽度: ${screenWidth}px
屏幕高度: ${screenHeight}px
可用宽度: ${innerWidth}px
可用高度: ${innerHeight}px
设备像素比: ${devicePixelRatio}
宽高比: ${screenRatio}`;
  
//   alert(screenInfo);
});
</script>

<style lang="scss" scoped>
.home-container {
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  position: relative;
  overflow: hidden;
  background-image: url("@/assets/images/home.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-color: #1a2a3a;
  background-position: center;
}

.header-bg {
  width: 100%;
  height: auto;
  padding: 24px 20px 10px 20px;
  margin: 0 auto;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.bottom-bg {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: auto;
  padding-bottom: 30px;
  margin: 0 auto;
}

/* 点击进入按钮 */
.enter-section {
  background-image: url("@/assets/images/btnBg.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 160px;
  height: 160px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  animation: pulse 1s ease-in-out infinite;

  &:active {
    transform: scale(0.95);
    // box-shadow: 0 4px 15px rgba(238, 90, 90, 0.3);
  }

  .enter-btn {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .enter-text {
    margin-top: -38px;
    color: #fff;
    text-align: center;
    font-family: "Alibaba PuHuiTi 3.0";
    font-size: 22px;
    font-style: normal;
    font-weight: 900;
    line-height: 23.62px; /* 107.365% */
    margin-left: 2px;
  }
}

@keyframes pulse {
  0%, 100% {
    // box-shadow: 0 0 0 0 rgba(138, 43, 226, 0.3);
    transform: scale(1);
  }
  50% {
    // box-shadow: 0 0 25px 8px rgba(138, 43, 226, 0.15);
    transform: scale(1.05);
  }
}

.right {
  background-image: url("@/assets/images/right.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 176px;
  height: 40.7px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: -35px;
}

.finger {
  background-image: url("@/assets/images/finger.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 90px;
  height: 97px;
  position: absolute;
  right: 24.5px;
  bottom: 57.6px;
  animation: fadeInOut 1s ease-in-out infinite;
}

@keyframes fadeInOut {
  0%, 100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}

@media (max-height: 720px) {
  .header-bg {
    padding: 10px 20px 10px 20px;
  }

  .bottom-bg {
    padding-bottom: 46px;
  }
  .right {
    margin-top: -36px;
  }
  .finger {
    width: 83px;
    height: 90px;
    right: 35px;
    bottom: 75px;
  }
  .enter-section {
    width: 170px;
    height: 170px;
  }
  .enter-text {
    margin-top: -38px;
    color: #fff;
    text-align: center;
    font-family: "Alibaba PuHuiTi 3.0";
    font-size: 20px !important;
    font-style: normal;
    font-weight: 900;
    line-height: 23.62px; /* 107.365% */
  }
}
@media (max-height: 675px) {
  .bottom-bg {
    padding-bottom: 20px;
  }
  .enter-section {
    width: 26vh;
    height: 26vh;
  }
  .finger {
    width: 83px;
    height: 90px;
    right: 30px;
    bottom: 7vh;
  }
}
</style>
